import React from "react"


const Badge = ( { product } ) => {
  // let out = []
  // if (product.extras.neuh === "J") {
  //   out.push(<div key={1} className="badge badge--neu"><span>NEU</span></div>)
  // }
  // if (out.length > 0) return <div className="badges">{out}</div>
  return <div className="badges nh-1 flex flex-row items-center">
    {product.extras.neuh === "J" && <div className="badge f7 badge--neu">NEU</div>}
    {product.extras.alter === "J" && <div className="badge f7 badge--alter">ab 18</div>}
    
    {product.extras.GreenLabel === "1" && <div className="badge tc f7 pa1 ph3 bg-green white">GREEN</div>}
    {product.extras.BannerNeu === "1" && <div className="badge tc f7 pa1 ph3 bg-blue white">NEU</div>}
    {product.extras.BannerAngebot === "1" && <div className="badge tc f7 pa1 ph3 bg-red white">ANGEBOT</div>}
  </div>
}

export const PillBadges = ( { product } ) => {
  // THe limited badge is an implementation in advance. Whenever we receive the
  // actual API prop, we can just change it to that.
  
  return (
    <div>
      {product.extras.neuh === "J" && <div className="pill-badge pill-badge--limitiert">NEU</div>}
      {product.extras.alter === "J" && <div className="pill-badge pill-badge--alter">ab 18</div>}
    </div>
  )
}

export default Badge



// WEBPACK FOOTER //
// ./src/components/Product/Badge.js